module.exports = __webpack_public_path__ + "img/kn.cd97ab0f.png";